<template>
  <div>
    <a-modal
      v-model:visible="visible"
      height="100vh"
      width="100%"
      :centered="true"
      :footer="null"
      :bodyStyle="{ padding: 0 }"
      @cancel="hide"
      wrap-class-name="full-modal"
    >
      <div v-if="mediaImages.length" class="page-container">
        <img
          v-if="
            mediaImages[imageIndex].type.includes('image')
          "
          class="image"
          :src="mediaImages[imageIndex].resized_images.dov1280x720"
          alt="image"
        />
        <video
          v-if="
            mediaImages[imageIndex].type.includes('video')
          "
          class="image"
          :src="mediaImages[imageIndex].url"
          controls
        />
      </div>
      <div class="slideshow-button-center">
        <div class="slideshow-button-container">
          <font-awesome-icon
            class="mr-2"
            :style="
              imageIndex != 0
                ? { color: getPrimaryColor(), cursor: 'pointer' }
                : { color: 'gray' }
            "
            :icon="['fas', 'arrow-left']"
            @click="imageIndex != 0 ? imageIndex-- : null"
          />
          <div class="slideshow-button-text">
            {{ imageIndex + 1 }} / {{ mediaImages.length }}
          </div>
          <font-awesome-icon
            class="mr-2"
            :style="
              imageIndex != mediaImages.length - 1
                ? { color: getPrimaryColor(), cursor: 'pointer' }
                : { color: 'gray' }
            "
            :icon="['fas', 'arrow-right']"
            @click="imageIndex != mediaImages.length - 1 ? imageIndex++ : null"
          />
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

library.add(faArrowLeft);
library.add(faArrowRight);

export default {
  name: "ImageFullScreenModal",
  data() {
    return {
      visible: false,
      mediaImages: [],
      imageIndex: 0
    };
  },

  methods: {
    showModal(mediaImages, imageIndex) {
      this.mediaImages = mediaImages;
      this.imageIndex = imageIndex;
      this.visible = true;
    },
    hide() {
      this.visible = false;
    }
  }
};
</script>

<style lang="scss">
.full-modal {
  .ant-modal-content {
    background-color: transparent;
    box-shadow: none;
    .ant-modal-close {
      .ant-modal-close-x {
        .ant-modal-close-icon {
          color: #ffffff;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.page-container {
  display: flex;
  justify-content: center;
}
.image {
  max-width: calc(100vw - 100px);
  height: calc(100vh - 82px);
  border-radius: 5px;
  object-fit: contain;
}

.slideshow-button-center {
  display: flex;
  justify-content: center;
  width: 100%;
}

.slideshow-button-container {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  padding: 14px;
  width: 199px;
  height: 52px;
  background: #ffffff;
  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin-top: 15px;
  margin-bottom: 15px;
}

.slideshow-button-text {
  font-family: "Lato";
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #0f1734;
}
.slideshow-button {
  font-family: "Lato";
  font-weight: 700;
  font-size: 30px;
  line-height: 24px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/ImageFullScreenModal.vue